export const chartReport = {
    constructor: "chart",
    options: {
        chart: {
            type: "spline",
            height: "100%",
            backgroundColor: "transparent",
        },
        rangeSelector: {
            enabled: false,
        },
        plotOptions: {
            line: {
                gapSize: 0,
                gapUnit: "value",
                dataGrouping: {
                    enabled: false,
                },
            },
            series: {
                marker: {
                    enabled: false,
                },
                turboThreshold: 0,
            },
        },
        xAxis: {
            visible: true,
            type: "datetime",
            title: {
                text: null,
            },
            tickInterval: 1800 * 1000,
        },
        yAxis: [
            {
                visible: true,
                floor: 0,
                softMax: 110,
                min: 40,
                tickInterval: 5,
                labels: {
                    format: "{value} dB",
                },
                title: {
                    enabled: false,
                },
            },
        ],
        legend: {
            enabled: false,
        },
        credits: {
            enabled: true,
            text: "@ Axioma Consultors Acústics",
        },
        time: {
            useUTC: false,
        },
        tooltip: {
            enabled: false, // disable the tooltip
        },
        title: {
            text: "",
        },
        series: [],
    },
    update: true,
    visible: false,
};
